module.exports = __webpack_public_path__ + "img/Spend Data Upload.a7a6cddb.svg";